import { apiRequest } from "../util/apiUtils";

export const dashboardCounts = async (params) => {
  try {
    const res = await apiRequest("get", `dashboard/count-analytics`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const dashboardTableOrders = async (params) => {
  try {
    const res = await apiRequest("get", `dashboard/table-ordercount`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};